module.exports = {
  appVersion: `${APP_VERSION}`,
  buildVersion: `${BUILD_VERSION}`,
};
